import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { StyleSheetsFacade } from './+state/styles';
import { StylesEffects } from './+state/styles/styles.effects';
import { reducer, STYLES_FEATURE_KEY } from './+state/styles/styles.reducer';

@NgModule({
  imports: [
    CommonModule,

    StoreModule.forFeature(STYLES_FEATURE_KEY, reducer),
    EffectsModule.forFeature([StylesEffects]),
  ],
  providers: [StyleSheetsFacade],
})
export class StyleStateModule {}
